// extracted by mini-css-extract-plugin
export var loadingSpinner = "_20-0";
export var spinnerContainer = "_20-1";